export const reCountryConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_COUNTRY_SUCCESS',
		REQUEST : 'GET_PAGED_COUNTRY_REQUEST',
		FAILURE : 'GET_PAGED_COUNTRY_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_COUNTRY_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_COUNTRY_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_COUNTRY_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_COUNTRY_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_COUNTRY_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_COUNTRY_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_COUNTRY_REQUEST',
		SUCCESS : 'GET_LIST_COUNTRY_SUCCESS',
		FAILURE : 'GET_LIST_COUNTRY_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_COUNTRY_REQUEST',
		SUCCESS : 'CREATE_COUNTRY_SUCCESS',
		FAILURE : 'CREATE_COUNTRY_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_COUNTRY_REQUEST',
		SUCCESS : 'DELETE_COUNTRY_SUCCESS',
		FAILURE : 'DELETE_COUNTRY_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_COUNTRY_REQUEST',
		SUCCESS : 'UPDATE_COUNTRY_SUCCESS',
		FAILURE : 'UPDATE_COUNTRY_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_COUNTRY_REQUEST',
		SUCCESS : 'RESTORE_COUNTRY_SUCCESS',
		FAILURE : 'RESTORE_COUNTRY_FAILURE'
	},
	CLEAR: 'CLEAR_COUNTRY'
}